export const SITE = {
  TITLE: "KIMCHIJJIM",
  SLOGAN: "CREATIVE WEB DEV / EXPERIENCE LAB / INTERACTION",
  DESCRIPTION: "L's Lab",
  SUBTEXT: "뭔가 간지나는 한 마디",
};